import { Api } from './repository.config';

const RESOURCE = '/products';

export const ProductsRepository = {
  async getListProducts() {
    return Api().get(`${RESOURCE}`);
  }
};
